export function tryStringify(obj) {
    try {
        return JSON.stringify(obj);
    }
    catch {
        return obj;
    }
}
